module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/252-mexico-eab3984955c24dd615cd054b40420425.svg";